const BROWSER_ID_KEY = "Browser_ID";

export const getBrowserId = (): string | null => {
  try {
    return localStorage.getItem(BROWSER_ID_KEY);
  } catch {
    return null;
  }
};

// Persist the browser_id only the first time we see it; never overwrite an
// existing value so the same id keeps being reused for this browser.
export const saveBrowserIdIfAbsent = (browserId?: string | null): void => {
  if (!browserId) return;
  try {
    if (!localStorage.getItem(BROWSER_ID_KEY)) {
      localStorage.setItem(BROWSER_ID_KEY, browserId);
    }
  } catch {
    // localStorage may be unavailable (e.g. SSR / privacy mode); ignore.
  }
};
